import React from "react";
import Navbar from "../../components/Navbar";
import reallygreatsit from "../../assets/images/reallygreatsite.png";
import "./Dashboard.css";

function Dashboard() {
  return (
    <div>
      <Navbar />
      <img src={reallygreatsit} className="dashboard-image" />
    </div>
  );
}

export default Dashboard;
